import React from 'react';
import { Linkedin, Instagram, Github, Youtube } from 'lucide-react';
import GradientLogo from './common/GradientLogo';
import { SOCIAL_LINKS } from '../config/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    { icon: <Linkedin className="w-5 h-5" />, href: SOCIAL_LINKS.LINKEDIN, label: "LinkedIn" },
    { icon: <Instagram className="w-5 h-5" />, href: SOCIAL_LINKS.INSTAGRAM, label: "Instagram" },
    { icon: <Github className="w-5 h-5" />, href: SOCIAL_LINKS.GITHUB, label: "GitHub" },
    { icon: <Youtube className="w-5 h-5" />, href: SOCIAL_LINKS.YOUTUBE, label: "YouTube" }
  ];
  
  const footerLinks = [
    // { text: "Termos de uso", href: "#" },
    // { text: "Política de privacidade", href: "#" },
    { text: "Contato", href: SOCIAL_LINKS.WHATSAPP_CONTACT }
  ];

  return (
    <footer className="bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] text-white">
      <div className="container mx-auto px-4 md:px-8 pt-12 pb-6 max-w-7xl">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <div className="mb-6 md:mb-0">
            <GradientLogo size="large" />
          </div>
          
          <div className="flex gap-4">
            {socialLinks.map((link, index) => (
              <a 
                key={index} 
                href={link.href} 
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors duration-200"
                aria-label={link.label}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
        
        <div className="border-t border-white/20 py-6 flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm opacity-80">
              © {currentYear} Java Dev Week. Todos os direitos reservados.
            </p>
          </div>
          
          <div className="flex flex-wrap gap-6">
            {footerLinks.map((link, index) => (
              <a 
                key={index} 
                href={link.href} 
                className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-200"
              >
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;